






























































import Vue from 'vue';
import {InitiatorClass} from '@/types/InitiatorClass';

export default Vue.extend({
  name: 'Initiator',
  props: {
    dialog: Boolean,
    users: Array,
    initiators: Array as () => InitiatorClass[]
  },
  data: () => ({
    valid: false,
    loginRules: [
      (v: string) => !!v || 'Обязательное поле'
    ],
    aliasRules: [
      (v: string) => !!v || 'Обязательное поле',
      (v: string) => v.search(/[^a-z]/gmi) < 0 || 'Разрешены только латинские буквы без пробелов'
    ],
    initiator: new InitiatorClass(),
    aliasError: '',
    userError: ''
  }),
  methods: {
    validate() {
      (this.$refs.form as any).validate();
      if (!this.initiator.user) {
        this.valid = false;
        this.userError = 'Пользователь не выбран';
      } else {
        this.userError = '';
      }
      if (this.initiators.some(v => v.alias == this.initiator.alias)) {
        this.valid = false;
        this.aliasError = 'Такой алиас уже используется';
      } else {
        this.aliasError = '';
      }
    },
    submit() {
      this.validate();
      if (this.valid) {
        this.$emit('initiatorAdd', this.initiator);
      }
    },
    reset() {
      this.$emit('reset');
    }
  }
});
